import React from 'react';
import { commaFormatCurrency } from '@ltvco/refresh-lib/utils';
import { Text } from '@ltvco/refresh-lib/theme';
import { CustomTooltip } from '../components';

export interface ICustomTooltipProps {
  active?: boolean;
  payload?: Array<{
    payload: {
      quarter: string;
      value: number;
      change_percent: number;
    };
  }>;
}

/**
 * Custom tooltip component for the chart (desktop hover)
 * Memoized to prevent unnecessary re-renders on every mouse move
 * @component
 */
export const CustomTooltipComponent: React.FC<ICustomTooltipProps> = React.memo(
  ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <CustomTooltip>
          <Text variant="body2" fontWeight="bold" mb={0.5}>
            {data.quarter}
          </Text>
          <Text variant="body1" color="text.secondary" mb={0.25}>
            {commaFormatCurrency(data.value)}
          </Text>
          <Text variant="body2" color="error.main">
            {data.change_percent}%
          </Text>
        </CustomTooltip>
      );
    }
    return null;
  },
);
